import React, {useEffect, useState} from 'react'
import {getByEducationGroupResource, getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileEducationForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()
    const [educationGroup, setEducationGroup] = useState('')
    const [educationType, setEducationType] = useState([])
    const [institution, setInstitution] = useState([])
    const [school, setSchool] = useState([])
    const [educationTitle, setEducationTitle] = useState([])

    const [otherInstitution, setOtherInstitution] = useState(false)
    const [otherSchool, setOtherSchool] = useState(false)
    const [otherTitle, setOtherTitle] = useState(false)

    const [showTypeError, setShowTypeError] = useState(false)
    const [showEnrollmentDateError, setShowEnrollmentDateError] = useState(false)
    const [showInstitutionError, setShowInstitutionError] = useState(false)
    const [showTitleError, setShowTitleError] = useState(false)
    const [showSchoolError, setShowSchoolError] = useState(false)
    const [showOtherInstitutionError, setShowOtherInstitutionError] = useState(false)
    const [showOtherTitleError, setShowOtherTitleError] = useState(false)
    const [showOtherSchoolError, setShowOtherSchoolError] = useState(false)
    const [backError, setBackError] = useState('');

    useEffect(() => {

        getResource('education_types').then((data) => {
            console.log(`education types`)
            console.log(data.data)
            setEducationType(data.data)
            console.log(`entity ... types`)
            console.log(entity)
            setEntity(entityTemp);
        })
        if (entityTemp && entityTemp.educationType) {
            setEducationGroup(entityTemp.educationType.educationGroup)
        }
        if (entityTemp && entityTemp.educationInstitution) {
            setOtherInstitution(entityTemp.educationInstitution.other)
        }
        if (entityTemp && entityTemp.educationSchool) {
            setOtherSchool(entityTemp.educationSchool.other)
        }
        if (entityTemp && entityTemp.educationTitle) {
            setOtherTitle(entityTemp.educationTitle.other)
        }


    }, []);

    useEffect(() => {
        console.log(educationGroup)
        getByEducationGroupResource('education_institutions/get_by_education_type', educationGroup).then((data) => {
            console.log(`education institutions`)
            console.log(data.data)
            setInstitution(data.data)
        })
        getByEducationGroupResource('educational_faculties/get_by_education_type', educationGroup).then((data) => {
            console.log(`education schools`)
            console.log(data.data)
            setSchool(data.data)
        })
        getByEducationGroupResource('education_fields/get_by_education_type', educationGroup).then((data) => {
            console.log(`education titles`)
            console.log(data.data)
            setEducationTitle(data.data)
        })
    }, [educationGroup])



    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-12 d-flex justify-content-around flex-wrap">
                            <div className="col-lg-7 col-12">
                                {(educationType && educationType.length > 0) &&
                                    (
                                        <Combo
                                            tooltipText="Одберете степен на образование"
                                            comboClass="combo-form"
                                            placeholder="Степен на образование"
                                            entity={(entity.educationType) && entity.educationType.name}
                                            onChange={(e) => {
                                                let chosenEducationType = {};
                                                chosenEducationType.id = e.target.value;
                                                setEntity({...entity, educationType: chosenEducationType})
                                                setShowTypeError(false)
                                                let el = educationType.find(el => el.id.toString() === chosenEducationType.id.toString());
                                                setEducationGroup(el.educationGroup)
                                            }}
                                            onClear={() => setEntity({...entity, educationType:null})}
                                            array={educationType}/>)}
                                {showTypeError && <b>Ве молиме одберете степен на образование</b>}
                                {(institution && institution.length > 0) &&
                                    <Combo
                                        tooltipText="Одберете институција"
                                        comboClass="combo-form"
                                        placeholder="Институција"
                                        entity={(entity.educationInstitution) && entity.educationInstitution.name}
                                        onChange={(e) => {
                                            let chosenInstitution = {};
                                            chosenInstitution.id = e.target.value;
                                            setEntity({...entity, educationInstitution: chosenInstitution})
                                            let el = institution.find(el => el.id.toString() === chosenInstitution.id.toString());
                                            setOtherInstitution(el.other)
                                            setShowInstitutionError(false)
                                        }}
                                        onClear={() => setEntity({...entity, educationInstitution:null})}
                                        array={institution}/>}
                                {showInstitutionError && <b>Ве молиме одберете институција</b>}

                                {otherInstitution && <input className="input-form w-100" type="text" placeholder="Друга институција"
                                                            value={entity.customEducationInstitution}
                                                            onChange={(e) => {
                                                                setEntity({...entity, customEducationInstitution: e.target.value})
                                                                setShowOtherInstitutionError(false)
                                                            }}
                                />}
                                {showOtherInstitutionError && <b>Ве молиме внесете институција</b>}

                                {(school && school.length > 0) &&
                                    <Combo
                                        tooltipText="Одберете факултет"
                                        comboClass="combo-form"
                                        placeholder="Факултет"
                                        entity={(entity.educationSchool) && entity.educationSchool.name}
                                        onChange={(e) => {
                                            let chosenSchool = {};
                                            chosenSchool.id = e.target.value;
                                            setEntity({...entity, educationSchool: chosenSchool})
                                            let el = school.find(el => el.id.toString() === chosenSchool.id.toString());
                                            setOtherSchool(el.other)
                                            setShowSchoolError(false)
                                        }}
                                        onClear={() => setEntity({...entity, educationSchool:null})}
                                        array={school}/>}
                                {showSchoolError && <b>Ве молиме одберете факултет</b>}

                                {otherSchool && <input className="input-form w-100" type="text" placeholder="Друг факултет"
                                                       value={entity.customEducationSchool}
                                                       onChange={(e) => {
                                                           setEntity({...entity, customEducationSchool: e.target.value})
                                                           setShowOtherSchoolError(false)
                                                       }}
                                />}
                                {showOtherSchoolError && <b>Ве молиме внесте факултет</b>}
                                {(educationTitle && educationTitle.length > 0) &&
                                    <Combo
                                        tooltipText="Одберете насока на образование"
                                        comboClass="combo-form"
                                        placeholder="Насока на образование"
                                        entity={(entity.educationTitle) && entity.educationTitle.name}
                                        onChange={(e) => {
                                            let chosenEducationTitle = {};
                                            chosenEducationTitle.id = e.target.value;
                                            setEntity({...entity, educationTitle: chosenEducationTitle})
                                            let el = educationTitle.find(el => el.id.toString() === chosenEducationTitle.id.toString());
                                            setOtherTitle(el.other)
                                            setShowTitleError(false)
                                        }}
                                        onClear={() => setEntity({...entity, educationTitle:null})}
                                        array={educationTitle}/>}
                                {showTitleError && <b>Ве молиме одберете насока на завршено образование</b>}

                                {otherTitle && <input className="input-form w-100" type="text" placeholder="Насока на образование"
                                                      value={entity.customEducationTitle}
                                                      onChange={(e) => {
                                                          setEntity({...entity, customEducationTitle: e.target.value})
                                                          setShowOtherTitleError(false)
                                                      }}
                                />}
                                {showOtherTitleError && <b>Ве молиме внесете насока на завршено образование</b>}
                                <input className="input-form w-100" type="number" required={true}
                                       step=".01"
                                       placeholder="Просечна оцена"
                                       value={entity.averageGrade}
                                       onChange={(e) => setEntity({...entity, averageGrade: e.target.value})}
                                />
                            </div>
                            <div className="col-lg-4 col-12">
                                <input className="input-form w-100" type="number" max="4" placeholder="Година на почеток"
                                       value={entity.enrollmentDate}
                                       onChange={(e) => {
                                           setEntity({...entity, enrollmentDate: e.target.value})
                                           setShowEnrollmentDateError(false)
                                       }}
                                />
                                {showEnrollmentDateError && <b>Ве молиме внесете година на почеток</b>}
                                <input className="input-form w-100" type="number" max="4" placeholder="Година на завршување"
                                       value={entity.completionDate}
                                       onChange={(e) => {
                                           setEntity({...entity, completionDate: e.target.value})
                                       }}
                                />
                            </div>
                        </div>
                        {backError && <b>{backError}</b>}
            <div className="col-12 d-flex justify-content-around flex-wrap">
                <div
                    className="btn-form"
                    onClick={() => {
                        setAddEntity(false)
                        setEntityTemp({candidate: entity.candidate})
                    }}
                >Затвори
                </div>
                <div className="btn-form"
                     onClick={(е) => {
                         console.log(`entity vo profileEducationForm ${entity}`)
                         if (entity.educationType && entity.educationType.id !== "0") {

                             if (!entity.enrollmentDate) {
                                 setShowEnrollmentDateError(true);
                             } else if ((educationGroup == null) || (educationGroup === "")) {
                                 updateResource('candidate_educations', entity)
                                     .then((data) => {
                                         console.log(data.data)
                                         setAddEntity(false)
                                         setEntityTemp({candidate: entity.candidate})
                                         setUpdateEntity(!updateEntity)
                                     }).catch((exception) => {
                                     setBackError(exception.response.data.message);
                                 })
                             } else if (educationGroup === "EDUCATION_SSS") {
                                 if (entity.educationInstitution && entity.educationInstitution.id !== "0") {
                                     if (!otherInstitution || (otherInstitution && entity.customEducationInstitution && entity.customEducationInstitution !== "")) {
                                         if (entity.educationTitle && entity.educationTitle.id !== "0") {
                                             if (!otherTitle || (otherTitle && entity.customEducationTitle && entity.customEducationTitle !== "")) {
                                                 updateResource('candidate_educations', entity)
                                                     .then((data) => {
                                                         console.log(data.data)
                                                         setAddEntity(false)
                                                         setEntityTemp({candidate: entity.candidate})
                                                         setUpdateEntity(!updateEntity)
                                                     }).catch((exception) => {
                                                     setBackError(exception.response.data.message);
                                                 })
                                             } else {
                                                 setShowOtherTitleError(true);
                                             }

                                         } else {
                                             setShowTitleError(true);
                                         }
                                     } else {
                                         setShowOtherInstitutionError(true);
                                     }
                                 } else {
                                     setShowInstitutionError(true);
                                 }
                                 //    sredno
                             } else {
                                 //    visoko

                                 if (entity.educationInstitution && entity.educationInstitution.id !== "0") {
                                     if (!otherInstitution || (otherInstitution && entity.customEducationInstitution && entity.customEducationInstitution !== "")) {
                                         if (entity.educationSchool && entity.educationSchool.id !== "0") {
                                             if (!otherSchool || (otherSchool && entity.customEducationSchool && entity.customEducationSchool !== "")) {

                                                 if (entity.educationTitle && entity.educationTitle.id !== "0") {
                                                     if (!otherTitle || (otherTitle && entity.customEducationTitle && entity.customEducationTitle !== "")) {
                                                         updateResource('candidate_educations', entity)
                                                             .then((data) => {
                                                                 console.log(data.data)
                                                                 setAddEntity(false)
                                                                 setEntityTemp({candidate: entity.candidate})
                                                                 setUpdateEntity(!updateEntity)
                                                             }).catch((exception) => {
                                                             setBackError(exception.response.data.message);
                                                         })
                                                     } else {
                                                         setShowOtherTitleError(true);
                                                     }
                                                 } else {
                                                     setShowTitleError(true);
                                                 }


                                             } else {
                                                 setShowOtherSchoolError(true);
                                             }

                                         } else {
                                             setShowSchoolError(true);
                                         }
                                     } else {
                                         setShowOtherInstitutionError(true);
                                     }
                                 } else {
                                     setShowInstitutionError(true);
                                 }


                             }
                         } else {
                             setShowTypeError(true)
                         }
                     }}>

                    Зачувај
                </div>
            </div>
            </>
            )
                }
        </div>
    )
}